/**
 * Actions are used to commit state mutations
 * and can contain asynchronous operations.
 * @category OperatorWallet
 */

export default {};
